import { render, staticRenderFns } from "./VipLabel.vue?vue&type=template&id=5fa85492&scoped=true"
import script from "./VipLabel.vue?vue&type=script&lang=js"
export * from "./VipLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa85492",
  null
  
)

export default component.exports